// 主流「成功提交」音效 — 类似 Apple Pay / 银行 App 确认音
// 三音上升 + 收尾余音，清脆温暖，无金币感

export function playCoinSound() {
  try {
    const AudioContext = window.AudioContext || window.webkitAudioContext;
    if (!AudioContext) return;
    const ctx = new AudioContext();

    // E5 → G5 → B5 → E6 上升大三和弦，标准「成功」音型
    const notes = [
      { freq: 659.3,  delay: 0,    dur: 0.13, vol: 0.26 },
      { freq: 783.9,  delay: 0.10, dur: 0.13, vol: 0.26 },
      { freq: 987.8,  delay: 0.20, dur: 0.16, vol: 0.30 },
      { freq: 1318.5, delay: 0.32, dur: 0.32, vol: 0.20 },
    ];

    notes.forEach(({ freq, delay, dur, vol }) => {
      const osc = ctx.createOscillator();
      const gain = ctx.createGain();
      const filter = ctx.createBiquadFilter();
      filter.type = 'lowpass';
      filter.frequency.value = 3800;

      osc.connect(filter);
      filter.connect(gain);
      gain.connect(ctx.destination);

      osc.type = 'triangle';
      osc.frequency.setValueAtTime(freq, ctx.currentTime + delay);
      osc.frequency.linearRampToValueAtTime(freq * 1.002, ctx.currentTime + delay + dur * 0.4);

      gain.gain.setValueAtTime(0, ctx.currentTime + delay);
      gain.gain.linearRampToValueAtTime(vol, ctx.currentTime + delay + 0.008);
      gain.gain.exponentialRampToValueAtTime(0.001, ctx.currentTime + delay + dur + 0.18);

      osc.start(ctx.currentTime + delay);
      osc.stop(ctx.currentTime + delay + dur + 0.25);
    });

    // 轻柔余音
    const tail = ctx.createOscillator();
    const tailGain = ctx.createGain();
    tail.connect(tailGain);
    tailGain.connect(ctx.destination);
    tail.type = 'sine';
    tail.frequency.value = 1318.5;
    tailGain.gain.setValueAtTime(0.05, ctx.currentTime + 0.64);
    tailGain.gain.exponentialRampToValueAtTime(0.001, ctx.currentTime + 1.2);
    tail.start(ctx.currentTime + 0.64);
    tail.stop(ctx.currentTime + 1.25);

  } catch (e) {}
}
